<!-- begin::Header -->
<div class="card-header border-0">
  <h3 class="card-title fw-bolder text-gray-900">Notifications</h3>
  <div class="card-toolbar">
    <!-- begin::Menu -->
    <button
      type="button"
      class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
      data-kt-menu-trigger="click"
      data-kt-menu-placement="bottom-end"
      data-kt-menu-flip="top-end"
    >
      <app-keenicon name="category" class="fs-2"></app-keenicon>
    </button>
    <app-dropdown-menu1></app-dropdown-menu1>
    <!-- end::Menu -->
  </div>
</div>
<!-- end::Header -->
<!-- begin::Body -->
<div class="card-body pt-0">
  <!-- begin::Weekly Schedule -->
  <div *ngIf="showSchedule" class="bg-light p-5 rounded">
    <h5 class="fw-bold text-gray-800 mb-4">Weekly Schedule</h5>
    <table class="table align-middle">
      <thead>
        <tr>
          <th>Day</th>
          <th>Status</th>
          <th>Start Time</th>
          <th>End Time</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let schedule of weeklySchedule">
          <td>{{ schedule.day }}</td>
          <td>
            <span
              class="badge rounded-pill"
              [ngClass]="{
                'badge-light-success': schedule.active,
                'badge-light-danger': !schedule.active
              }"
            >
              {{ schedule.active ? 'Active' : 'Inactive' }}
            </span>
          </td>
          <td>{{ schedule.start || 'Not Scheduled' }}</td>
          <td>{{ schedule.end || 'Not Scheduled' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- end::Weekly Schedule -->

  <!-- begin::Item -->
  <div
    class="d-flex align-items-center bg-light-warning rounded p-5 mb-7"
    (click)="toggleSchedule()"
    style="cursor: pointer"
  >
    <!-- begin::Icon -->
    <span class="svg-icon text-warning me-5">
      <app-keenicon name="calendar-clock" class="fs-1"></app-keenicon>
    </span>
    <!-- end::Icon -->
    <!-- begin::Title -->
    <div class="flex-grow-1 me-2">
      <a href="#" class="fw-bolder text-gray-800 text-hover-primary fs-6">
        Weekly Schedule
      </a>
      <span class="text-muted fw-bold d-block">Click to View Schedule</span>
    </div>
    <!-- end::Title -->
    <!-- begin::Label -->
    <span class="fw-bolder text-warning py-1">
      {{ showSchedule ? 'Hide' : 'Show' }}
    </span>
    <!-- end::Label -->
  </div>
  <!-- end::Item -->

  <!-- Other Notification Items -->
  <div class="d-flex align-items-center bg-light-success rounded p-5 mb-7">
    <span class="svg-icon text-success me-5">
      <app-keenicon name="abstract-26" class="fs-1"></app-keenicon>
    </span>
    <div class="flex-grow-1 me-2">
      <a href="#" class="fw-bolder text-gray-800 text-hover-primary fs-6">
        Navigation optimization
      </a>
      <span class="text-muted fw-bold d-block">Due in 2 Days</span>
    </div>
    <span class="fw-bolder text-success py-1">+50%</span>
  </div>
  <!-- Add more items as needed -->
</div>
<!-- end::Body -->
